import { render, staticRenderFns } from "./RoomEquipmentView.vue?vue&type=template&id=2d085ce2&scoped=true&"
import script from "./RoomEquipmentView.vue?vue&type=script&lang=js&"
export * from "./RoomEquipmentView.vue?vue&type=script&lang=js&"
import style0 from "./RoomEquipmentView.vue?vue&type=style&index=0&id=2d085ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d085ce2",
  null
  
)

export default component.exports